import { Tag, Space, Button } from "antd";
import { setIcons } from "@/utils/common";

export const formTab = [
  {
    label: "账号",
    name: "mobile",
    type: "input",
  },
  {
    label: "昵称",
    name: "nickName",
    type: "input",
  },
  {
    label: "真实名称",
    name: "realName",
    type: "input",
  },
  {
    label: "时间范围",
    name: "rangePicker",
    type: "rangePicker",
    width: "380px",
  },
];

export const columns = (editWithdraw: any, deleteWithdraw: any) => [
  // {
  //   title: "ID",
  //   dataIndex: "id",
  //   key: "id",
  // },
  // {
  //   title: "userId",
  //   dataIndex: "userId",
  //   key: "userId",
  // },
  {
    title: "用户业务ID",
    dataIndex: "userBusinessId",
    key: "userBusinessId",
  },
  {
    title: "账号",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "用户昵称",
    dataIndex: "nickName",
    key: "nickName",
  },
  {
    title: "用户真实名称",
    dataIndex: "realName",
    key: "realName",
  },
  // {
  //   title: "用户等级",
  //   dataIndex: "userLevel",
  //   key: "userLevel",
  // },
  // {
  //   title: "支付宝账户",
  //   dataIndex: "alipayPaymentAccount",
  //   key: "alipayPaymentAccount",
  // },
  {
    title: "银行名称",
    dataIndex: "bankName",
    key: "bankName",
  },
  {
    title: "银行卡号",
    dataIndex: "bankcardNum",
    key: "bankcardNum",
  },
  {
    title: "卡类型",
    dataIndex: "cardTypeStr",
    key: "cardTypeStr",
  },
  {
    title: "身份证号",
    dataIndex: "identityNumber",
    key: "identityNumber",
  },
  {
    title: "提现手机号",
    dataIndex: "cashMobile",
    key: "cashMobile",
  },
  {
    title: "操作",
    dataIndex: "id",
    key: "operation",
    fixed: "right",
    render: (val: string, rows: any) => (
      <Space size="small">
        <Button
          size="small"
          icon={setIcons("EditOutlined")}
          type="text"
          onClick={() => {
            editWithdraw(rows);
          }}
        >
          修改
        </Button>
        <Button
          size="small"
          icon={setIcons("DeleteOutlined")}
          type="text"
          onClick={() => {
            deleteWithdraw(val);
          }}
        >
          删除
        </Button>
      </Space>
    ),
  },
];



export const userEditFormTab = [
  // {
  //   label: "提现方式",
  //   name: "cardType",
  //   type: "select",
  //   options: [
  //     { label: "银行卡", value: "1" },
  //     { label: "支付宝", value: "2" }
  //   ],
  //   required: true,
  //   rules: [
  //     { required: true, message: "请选择提现方式" }
  //   ]
  // },
  {
    label: "银行名称",
    name: "bankName",
    type: "input",
    required: true,
    // showCondition: "cardType === '1'",
    width: "320px",
    rules: [
      { required: true, message: "请输入银行名称" },
      { min: 2, max: 50, message: "银行名称长度为2-50个字符" }
    ]
  },
  {
    label: "银行卡号",
    name: "bankcardNum",
    type: "input",
    required: true,
    width: "320px",
    // showCondition: "cardType === '1'",
    rules: [
      { required: true, message: "请输入银行卡号" },
      { pattern: /^\d{14,21}$/, message: "银行卡号应为14-21位数字" }
    ]
  },
  // {
  //   label: "支付宝账户",
  //   name: "alipayPaymentAccount",
  //   type: "input",
  //   required: true,
  //   showCondition: "cardType === '2'",
  //   rules: [
  //     { required: true, message: "请输入支付宝账户" },
  //     { min: 6, max: 50, message: "支付宝账户长度为6-50个字符" }
  //   ]
  // },
  {
    label: "提现手机号",
    name: "cashMobile",
    type: "input",
    required: true,
    width: "320px",
    rules: [
      { required: true, message: "请输入提现手机号" },
      { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码" }
    ]
  },
  {
    label: "身份证号",
    name: "identityNumber",
    type: "input",
    width: "320px",
    required: true,
    rules: [
      { required: true, message: "请输入身份证号" },
      { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: "请输入正确的身份证号码" }
    ]
  },
  {
    label: "真实名称",
    name: "realName",
    type: "input",
    width: "320px",
    required: true,
    rules: [
      { required: true, message: "请输入真实名称" },
      { min: 2, max: 20, message: "真实名称长度为2-20个字符" },
      { pattern: /^[\u4e00-\u9fa5a-zA-Z\s]+$/, message: "真实名称只能包含中文、英文和空格" }
    ]
  },
];